import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Pagination from '../Pagination'
import PageCategoriesPostsLayout from '../PageCategoriesPostsLayout'
import { beautifyUrlPath } from '../../../common/utils'

const NewsCategoryLayout = ({
  data: { items: posts, total, currentPage },
  title,
}) => {
  const postData = useMemo(() => {
    if (posts?.length) {
      return posts.map((item) => {
        const blogUrl =
          item.category.type === 'newsroom'
            ? item.externalLink || beautifyUrlPath(`newsroom/${item.slug}`)
            : beautifyUrlPath(item.slug)

        return {
          ...item,
          path: blogUrl,
          thumbnailAsset: item.imageAsset,
          publishedAt: item.updatedAt,
        }
      })
    }
  }, [posts])

  return (
    <div className="my-5 block px-5 md:px-2 lg:my-8 lg:space-x-5 lg:px-0">
      <div className="w-full lg:w-7/10">
        <PageCategoriesPostsLayout data={postData} categoryTitle={title} />
      </div>
      <div className="w-full lg:w-7/10">
        <Pagination itemCount={total} currentPageNumber={currentPage} />
      </div>
    </div>
  )
}

NewsCategoryLayout.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

export default NewsCategoryLayout
